module.exports = __webpack_public_path__ + "img/food-15.0e852d50.jpg";